import { defineMessages } from 'react-intl';

const productCardMessages = defineMessages({
  editProduct: {
    id: 'productCard.dropdown.editProduct',
    defaultMessage: 'Edit product',
    description: 'Product card edit product dropdown item',
  },
  deleteProduct: {
    id: 'productCard.dropdown.deleteProduct',
    defaultMessage: 'Delete product',
    description: 'Product card delete product dropdown item',
  },
  setAsRetired: {
    id: 'productCard.dropdown.setAsRetired',
    defaultMessage: 'Retire product',
    description: 'Product card set as retired dropdown item',
  },
  setAsActive: {
    id: 'productCard.dropdown.setAsActive',
    defaultMessage: 'Activate product',
    description: 'Product card set as active dropdown item',
  },
  productType: {
    id: 'productCard.productType',
    defaultMessage: 'Product type',
    description: 'Product card product type label',
  },
  version: {
    id: 'productCard.version',
    defaultMessage: 'Version',
    description: 'Product card version label',
  },
  updatedOn: {
    id: 'productCard.updatedOn',
    defaultMessage: 'Updated on {date} at {time}',
    description: 'Product card updatedOn label',
  },
  productIdentifier: {
    id: 'productCard.productIdentifier',
    defaultMessage: 'Product identifier',
    description: 'Product card product identifier label',
  },
  projectIdentifier: {
    id: 'productCard.projectIdentifier',
    defaultMessage: 'Project identifier',
    description: 'Product card project identifier label',
  },
  navigatorIdentifier: {
    id: 'productCard.navigatorIdentifier',
    defaultMessage: 'Navigator identifier',
    description: 'Product card navigator identifier label',
  },
});

export { productCardMessages };
